import * as React from 'react';
import { CoughAnalysisSet } from 'webportalclient';

export interface ConfirmationPageProps {
    analysisSet: CoughAnalysisSet;
    hourSegment: number;
    eventCount: number;
}

export const ConfirmationPage = (props: ConfirmationPageProps) => {
    return (
        <div>
            <div className="row">
                <div className="col-md-12">
                    <h2 className="text-primary">Confirmation</h2>
                </div>
                <div className="col-md-12">
                    <p>You are about to import events for the following subject</p>
                    <div className="row">
                        <div style={{ fontSize: '50px', textAlign: 'center' }} className="col-sm-2"><i className="fas fa-user" aria-hidden="true"></i></div>
                        <div className="col-sm-10">
                            <h3>{props.analysisSet.session.visit.subject.number}</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div style={{ fontSize: '50px', textAlign: 'center' }} className="col-sm-2"><i className="fas fa-calendar" aria-hidden="true"></i></div>
                        <div className="col-sm-10">
                            <h3>{props.analysisSet.session.visit.name}</h3>
                            <p className="text-muted">{props.analysisSet.session.name}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div style={{ fontSize: '50px', textAlign: 'center' }} className="col-sm-2"><i className="fas fa-clock" aria-hidden="true"></i></div>
                        <div className="col-sm-10">
                            <h3>Hour Segment</h3>
                            <p className="text-muted">{props.hourSegment}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div style={{ fontSize: '50px', textAlign: 'center' }} className="col-sm-2"><i className="fas fa-thumbtack" aria-hidden="true"></i></div>
                        <div className="col-sm-10">
                            <h3>Events</h3>
                            <p className="text-muted">{props.eventCount}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
